import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { StateWithCompany } from '../company-state';
import { getCompanyState } from './feature.selector';

export const getAddCompanyState: MemoizedSelector<StateWithCompany, StateUtils.LoaderState<string>> = createSelector(
  getCompanyState,
  (state) => state?.add || {},
);

export const getAddCompanyLoading: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getAddCompanyState,
  (state) => state.loading,
);

export const getAddCompanyError: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getAddCompanyState,
  (state) => state.error,
);

export const getAddCompanyValue: MemoizedSelector<StateWithCompany, string> = createSelector(
  getAddCompanyState,
  (state) => state.value,
);
